import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.homework.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_HOMEWORK_ASYNC: `${uid}.saveHomeworkAsync`,
    SAVE_HOMEWORK_SUCCESS: `${uid}.saveHomeworkSuccess`,
    SAVE_HOMEWORK_FAILURE: `${uid}.saveHomeworkFailure`,
};

export { ActionTypes };
